import { getController } from '@/services/service'

const url = 'handovertemplates'

export const handoverTemplateService = {
	...getController<
		Api.HandoverTemplate,
		Api.HandoverTemplatePostInput,
		Api.HandoverTemplateUpdateInput
	>(url),
}
